import { getFirstPartyPatientByIdentifier } from '@ctw/shared/api/fhir/patient-helper';
import { SYSTEM_ZUS_UNIVERSAL_ID } from '@ctw/shared/api/fhir/system-urls';
import { useFeatureFlag } from '@ctw/shared/context/feature-flag-provider';
import { useCtwQuery } from '@ctw/shared/hooks/use-ctw-query';
import { QUERY_KEY_UPID_PATIENT } from '@ctw/shared/utils/query-keys';

interface UseGetPatientByUpid {
  upid: string;
  enabled?: boolean;
}

export const useGetPatientByUpid = ({ upid, enabled = true }: UseGetPatientByUpid) => {
  const crossBuilderLookup = useFeatureFlag('ctw-cross-builder-upid-lookup');
  return useCtwQuery({
    queryId: QUERY_KEY_UPID_PATIENT,
    queryKey: [upid],
    queryFn: async ({ ctwFetch, requestContext }) =>
      getFirstPartyPatientByIdentifier(
        ctwFetch,
        requestContext,
        upid,
        SYSTEM_ZUS_UNIVERSAL_ID,
        crossBuilderLookup,
      ),
    enabled,
  });
};
